import { Box, InputAdornment, makeStyles, TextField } from "@material-ui/core"
import NCSvgIcon from "./NCSvgIcon"

const useStyles = makeStyles(() => ({
  input: {
    fontSize: "14px",
    "&.MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#D1D5DB"
      },
      "&:hover fieldset": {
        borderColor: "#1EAAC4"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1EAAC4",
        borderWidth: "1px"
      }
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 14px"
    }
  },
  noFill: {
    color: "red"
  }
}))

const NCInput = props => {
  const cls = useStyles()
  const { startIcon, ...rest } = props

  return (
    <TextField
  {...rest}
  error={props.error || false}
  onInput={e => {
    if (props.max !== undefined && +e.target.value > props.max) {
      e.target.value = props.max
    }
    if (props.min !== undefined && +e.target.value < props.min) {
      e.target.value = props.min
    }
  }}
  InputProps={{
    ...props.InputProps,
    className: cls.input,
    readOnly: props.readOnly || false,
    startAdornment: startIcon ? (
      <InputAdornment position="start">
        <Box fontSize={"24px"}>
          <NCSvgIcon
            component={startIcon}
            inheritViewBox
            className={cls.noFill}
          />
        </Box>
      </InputAdornment>
    ) : null,
    inputProps: {
      ...props.inputProps,
      type: props.type,
      min: props.min,
      max: props.max
    }
  }}
  SelectProps={{
    native: true
  }}
  className={props.className}
  variant="outlined"
/>
  )
}

export default NCInput
